import { MdArrowBack } from 'react-icons/md';
import { LuWatch } from 'react-icons/lu';
import { MdContentCopy } from 'react-icons/md';
import { FaHandPointRight } from 'react-icons/fa';
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

export default function VirtualAccount() {
	const [copySuccess, setCopySuccess] = useState(false);
	const reservationId = 7;
	const jsonData = {
		content: [
			{
				merchantCode: 'TST_jaakdjfkadjfk',
				reservationId: 10109,
				accountName: 'Jerrry',
				virtualAccountName: 'Spay Business Solutions LTD/Jerry',
				virtualAccountNumber: '9100005726',
				currency: 'NGN',
				batchId: '591920230721124528',
				expiryDate: '2023-07-22T02:17:39.364Z',
				phone: '08099387462',
				email: 'test@test.com',
				accountState: 'PENDING',
				durationLimit: 2,
				status: 'CREATED',
				charge: 2.39,
				accountType: 'Dynamic',
				customerId: '086a7f80-5ee4-4938-b728-d92fb0136a29',
				callbackUrl: 'https://callingback.com',
				createdOn: '2023-07-22T02:17:39.364Z',
			},
		],
		count: 1,
		total: 1,
		last: true,
	};

	const jsonData2 = {
		content: [
			{
				merchantCode: 'TST_jaakdjfkadjfk',
				reservationId: 10109,
				accountName: 'Jerrry',
				virtualAccountName: 'Spay Business Solutions LTD/Jerry',
				virtualAccountNumber: '9100005726',
				currency: 'NGN',
				batchId: '591920230721124528',
				expiryDate: '2023-07-22T02:17:39.364Z',
				phone: '08099387462',
				email: 'test@test.com',
				accountState: 'PENDING',
				durationLimit: 2,
				status: 'CREATED',
				charge: 2.39,
				accountType: 'Dynamic',
				customerId: '086a7f80-5ee4-4938-b728-d92fb0136a29',
				callbackUrl: 'https://callingback.com',
				createdOn: '2023-07-22T02:17:39.364Z',
			},
		],
		count: 1,
		total: 1,
		last: true,
	};

	const jsonData3 = {
		merchantCode: 'TST_jaakdjfkadjfk',
		reservationId: 10109,
		accountName: 'Jerrry',
		virtualAccountName: 'Spay Business Solutions LTD/Jerry',
		virtualAccountNumber: '9100005726',
		currency: 'NGN',
		batchId: '591920230721124528',
		expiryDate: '2023-07-22T02:17:39.364Z',
		phone: '08099387462',
		email: 'test@test.com',
		accountState: 'PENDING',
		durationLimit: 2,
		status: 'CREATED',
		charge: 2.39,
		accountType: 'Dynamic',
		customerId: '086a7f80-5ee4-4938-b728-d92fb0136a29',
		callbackUrl: 'https://callingback.com',
		createdOn: '2023-07-22T02:17:39.364Z',
	};

	const copyJsonToClipboard = (json) => {
		navigator.clipboard
			.writeText(JSON.stringify(json, null, 2))
			.then(() => {
				setCopySuccess(true);
				setTimeout(() => setCopySuccess(false), 2000);
			})
			.catch((err) => {
				console.error('Failed to copy: ', err);
			});
	};
	return (
		<main className="px-1 2xl:px-10 pt-20 lg:pt-10">
			<div className="block w-100 flex-row mt-5 pb-20">
				<div className="block mt-30 w-full sm:w-screen">
					<h1 className="text-3xl font-bold text-gray-700">Virtual Account</h1>
					<p className="text-lg mt-3 text-gray-700 w-full sm:w-6/12">
						This implementation contains endpoints to create a virtual account
						with First Bank of Nigeria to ensure end users can make payments
						into the created account.
					</p>
				</div>

				<div className="border-t border-gray-300 my-10 w-full sm:w-8/12"></div>

				<div className="mt-30 w-full sm:w-8/12">
					<div className=" flex pt-5 px-4 border-l-4 border-gray-400 bg-gray-50 bg-opacity-60">
						<div className="mt-1">
							<FaHandPointRight size="20" className="text-yellow-400" />
						</div>
						<div className="block pl-3">
							<p className="text-base font-semibold text-gray-600 sm:text-xl">
								Please note that all endpoints are protected and require
								merchants to obtain an api-key which is to be passed as SHA-256
								encoded string in the request header and a tag (merchantCode)
								field as a request param of the request being sent.
							</p>
						</div>
					</div>
				</div>

				<div id="get1" className="block sm:w-full sm:w-10/12 pt-4 items-center">
					<p className="text-xl text-gray-700 font-semibold sm:w-full">
						Making a GET request to the endpoint
					</p>
					<p className="text-sm mt-3 text-gray-700 sm:w-full sm:w-5/12">
						<NavLink
							legacyBehavior
							to="https://testcollections. virtual account with First bank of Nigeria spaybusiness.com/api/v1/fbn/vaccount"
						>
							<div className="text-blue-900 underline">
								https://testcollections.spaybusiness.com/api/v1/fbn/vaccount
							</div>
						</NavLink>
					</p>
					<p className="text-sm mt-3 text-gray-700 sm:w-full sm:w-8/12 ">
						With the following details as request params, all virtual accounts
						that has been created will be fetched
					</p>

					<div className="mt-4 w-full sm:w-8/12">
						<div className="overflow-x-auto">
							<table className="w-full border-collapse border border-gray-300">
								<thead>
									<tr className="bg-gray-100">
										<th className="border border-gray-300 p-2 text-base text-gray-700 font-semibold">
											S/N
										</th>
										<th className="border border-gray-300 p-2 text-base text-gray-700 font-semibold">
											Property
										</th>
										<th className="border border-gray-300 p-2 text-base text-gray-700 font-semibold">
											Data Type
										</th>
										<th className="border border-gray-300 p-2 text-base text-gray-700 font-semibold">
											Example
										</th>
										<th className="border border-gray-300 p-2 text-base text-gray-700 font-semibold">
											Description
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											1
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											merchantCode
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											string
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											“TST_jaakdjfkadjfk”
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											This will be gotten once user has successfully signed up
											on https://spaybusiness.com
										</td>
									</tr>
									<tr className="bg-gray-100">
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											2
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											offset
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											int
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											1
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											Starting point of the record to be pulled, often
											encouraged to support pagination
										</td>
									</tr>
									<tr>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											3
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											limit
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											int
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											20
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											Needed to reduce the amount of data being pulled at a time
										</td>
									</tr>
									<tr className="bg-gray-100">
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											4
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											tag
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											string
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											“TST_jaakdjfkadjfk”
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											This is the same as merchant code.
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<p className="text-sm mt-2 text-gray-700 sm:w-full sm:w-8/12">
						Sample Response body with the status code of 200
					</p>
					<div className="w-full sm:w-8/12 h-auto bg-gray-50 mt-7">
						<div className="w-full overflow-x-auto">
							<div className="flex justify-between">
								<p className="ml-1 text-black text-sm sm:text-md mt-2">JSON</p>
								<div
									className="cursor-pointer mt-2 mr-2"
									onClick={() => copyJsonToClipboard(jsonData)}
								>
									<MdContentCopy size="16" className="text-gray-600" />
									{copySuccess && (
										<span className="text-black-500 ml-2">Copied!</span>
									)}
								</div>
							</div>

							<pre className="ml-1 text-xs mt-2 sm:mt-3">
								{JSON.stringify(jsonData, null, 2)}
							</pre>
						</div>
					</div>
				</div>

				<div
					id="post2"
					className="block sm:w-full sm:w-10/12 pt-4 items-center"
				>
					<p className="text-xl text-gray-700 font-semibold sm:w-full sm:w-8/12">
						Making a POST request to the endpoint
					</p>
					<p className="text-sm mt-3 text-gray-700 sm:w-full sm:w-8/12">
						<NavLink
							legacyBehavior
							href="https://testcollections.spaybusiness.com/api/v1/fbn/vaccount"
						>
							<div className="text-blue-900 underline">
								https://testcollections.spaybusiness.com/api/v1/fbn/vaccount
							</div>
						</NavLink>
					</p>
					<p className="text-sm mt-3 text-gray-700">
						With the following details as{' '}
						<span className="font-bold">JSON BODY</span> , a virtual account
						with First bank of Nigeria will be created.
					</p>

					<div className="mt-4 w-full sm:w-8/12">
						<div className="overflow-x-auto">
							<table className="w-full border-collapse border border-gray-300">
								<thead>
									<tr className="bg-gray-100">
										<th className="border border-gray-300 p-2 text-base text-gray-700 font-semibold">
											S/N
										</th>
										<th className="border border-gray-300 p-2 text-base text-gray-700 font-semibold">
											Property
										</th>
										<th className="border border-gray-300 p-2 text-base text-gray-700 font-semibold">
											Data Type
										</th>
										<th className="border border-gray-300 p-2 text-base text-gray-700 font-semibold">
											Example
										</th>
										<th className="border border-gray-300 p-2 text-base text-gray-700 font-semibold">
											Description
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											1
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											accountName
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											string
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											&quot;Jerry&quot;
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											This could be customer&quot;s name or merchant&quot;s name
										</td>
									</tr>
									<tr className="bg-gray-100">
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											2
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											merchantCode
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											string
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											“TST_jaakdjfkadjfk”
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											This will be gotten once user has successfully signed up
											on https://spaybusiness.com
										</td>
									</tr>
									<tr>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											3
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											durationType
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											string
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											DAY or HOUR
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											To state when the virtual account created will expire.
											These are the two types of duration type available for now
										</td>
									</tr>
									<tr className="bg-gray-100">
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											4
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											accountType
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											int
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											“1 or 2”
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											Static account = 1 and Dynamic account is 2. These are the
											two types of account type available for now
										</td>
									</tr>
									<tr>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											5
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											expiryLimit
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											int
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											“1 or 5”
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											States how long it will take the virtual account to
											expire. Saying durationType: DAY and expiryLimit: 2. This
											means account created will expire in two days
										</td>
									</tr>
									<tr className="bg-gray-100">
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											6
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											email
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											string
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											test@test.com
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											Customer email
										</td>
									</tr>
									<tr>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											7
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											callbackUrl
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											string
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											https://callingback.com
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											This is a dedicated url to be called when customer
											successfully made payment
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<p className="text-sm mt-2 text-gray-700 sm:w-full sm:w-8/12">
						Sample Response body with the status code of 200
					</p>
					<div className="w-full sm:w-8/12 h-auto bg-gray-50 mt-7">
						<div className=" overflow-x-auto">
							<div className="flex justify-between">
								<p className="ml-1 text-black text-sm sm:text-md mt-2">JSON</p>
								<div
									className="cursor-pointer mt-2 mr-2"
									onClick={() => copyJsonToClipboard(jsonData2)}
								>
									<MdContentCopy size="16" className="text-gray-600" />
									{copySuccess && (
										<span className="text-black-500 ml-2">Copied!</span>
									)}
								</div>
							</div>

							<pre className="ml-1 text-xs mt-2 sm:mt-3">
								{JSON.stringify(jsonData2, null, 2)}
							</pre>
						</div>
					</div>
				</div>
				<div id="get2" className="block sm:w-full sm:w-10/12 pt-4 items-center">
					<p className="text-xl text-gray-700 font-semibold sm:w-full sm:w-8/12">
						Making a GET request to the endpoint
					</p>
					<p className="text-sm mt-3 text-gray-700 sm:w-full sm:w-8/12">
						<NavLink
							legacyBehavior
							to={`https://testcollections.spaybusiness.com/api/v1/fbn/vaccount/${reservationId}`}
						>
							<a className="text-blue-900 underline">
								https://testcollections.spaybusiness.com/api/v1/fbn/vaccount/
								{reservationId}
							</a>
						</NavLink>
					</p>
					<p className="text-sm mt-3 text-gray-700 ">
						With the following details as{' '}
						<span className="font-bold">JSON BODY</span> , a virtual account
						with First bank of Nigeria will be created.
					</p>

					<div className="mt-4 w-full sm:w-8/12">
						<div className="overflow-x-auto">
							<table className="w-full border-collapse border border-gray-300">
								<thead>
									<tr className="bg-gray-100">
										<th className="border border-gray-300 p-2 text-base text-gray-700 font-semibold">
											S/N
										</th>
										<th className="border border-gray-300 p-2 text-base text-gray-700 font-semibold">
											Property
										</th>
										<th className="border border-gray-300 p-2 text-base text-gray-700 font-semibold">
											Data Type
										</th>
										<th className="border border-gray-300 p-2 text-base text-gray-700 font-semibold">
											Example
										</th>
										<th className="border border-gray-300 p-2 text-base text-gray-700 font-semibold">
											Description
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											1
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											reservationId
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											string
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											This is the id gotten from the create virtual account leg
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											10767
										</td>
									</tr>
									<tr className="bg-gray-100">
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											2
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											merchantCode
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											string
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											“TST_jaakdjfkadjfk”
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											This will be gotten once user has successfully signed up
											on https://spaybusiness.com
										</td>
									</tr>
									<tr>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											3
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											tag
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											string
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											“TST_jaakdjfkadj fk”
										</td>
										<td className="border border-gray-300 p-2 text-sm mt-3 text-gray-700">
											This is the same as merchant code
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<p className="text-sm mt-2 text-gray-700 sm:w-full sm:w-8/12">
						Sample Response body with the status code of 200
					</p>
					<div className="w-full sm:w-8/12 h-auto bg-gray-50 mt-7">
						<div className="overflow-x-auto">
							<div className="flex justify-between">
								<p className="ml-1 text-black text-sm sm:text-md mt-2">JSON</p>
								<div
									className="cursor-pointer mt-2 mr-2"
									onClick={() => copyJsonToClipboard(jsonData3)}
								>
									<MdContentCopy size="16" className="text-gray-600" />
									{copySuccess && (
										<span className="text-black-500 ml-2">Copied!</span>
									)}
								</div>
							</div>

							<pre className="ml-1 text-xs mt-2 sm:mt-3">
								{JSON.stringify(jsonData3, null, 2)}
							</pre>
						</div>
					</div>
				</div>

				<div className="border-t border-gray-300 w-full my-10"></div>

				<div className="sm:flex pb-12 block w-7/12 justify-between">
					<NavLink to="/subscription">
						<div className="flex">
							<div className="sm:mt-1 mt-2">
								<MdArrowBack size={16} color="gray" />
							</div>
							<p className="sm:text-base sm:mt-0 mt-2 ml-2 sm:font-medium text-xs text-gray-600">
								Subscription
							</p>
						</div>
					</NavLink>
				</div>
				<div className="hidden lg:flex lg:basis-1/5 lg:overscroll-none lg:min-h-full overflow-clip">
					<div className="lg:w-40 2xl:w-52 lg:fixed lg:top-52 lg:right-1 xl:right-4 2xl:right-10">
						<div className="mb-2">
							<h3>Table of Contents</h3>
						</div>
						<div className="">
							<a href="#get1">
								<p className="text-sm">Making a GET request to the endpoint</p>
							</a>
							<a href="#post1">
								<p className="text-sm">Making a POST request to the endpoint</p>
							</a>
							<a href="#get2">
								<p className="text-sm">Making a GET request to the endpoint</p>
							</a>
						</div>
					</div>
				</div>
			</div>
		</main>
	);
}
